import { ukShoeSizes, euShoeSizes } from './searchFIlters'

export const searchFilters = { ukShoeSizes, euShoeSizes }
